<template><section><h3>图表介绍</h3>
<p>Funnel Chart，漏斗图。</p>
<h3>attrs</h3>
<p>attrs 包含若干布局属性，将这些属性放入 Object 对象传入组件</p>
<table>
<thead>
<tr>
<th>属性名</th>
<th>类型</th>
<th>默认值</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>align</td>
<td>String</td>
<td>'center'</td>
<td>组件位置，可选值 left、center、right</td>
</tr>
<tr>
<td>pyramid</td>
<td>Boolean</td>
<td>false</td>
<td>漏斗形状是否为金字塔底</td>
</tr>
<tr>
<td>clientRect</td>
<td>Object</td>
<td>{top,right,bottom,left,width,height}</td>
<td>设置了 width,heigh,优先与 bottom,right</td>
</tr>
</tbody>
</table>
<h3>style 属性</h3>
<p>组件中可以自定义属性的元素如下表：</p>
<table>
<thead>
<tr>
<th>名称</th>
<th>基本类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>polygon</td>
<td>面</td>
<td>漏斗区块样式</td>
</tr>
<tr>
<td>polygon:hover</td>
<td>面</td>
<td>鼠标 hover 时漏斗区块样式</td>
</tr>
<tr>
<td>guideText</td>
<td>文本</td>
<td>组件上的文本样式</td>
</tr>
<tr>
<td>guideline</td>
<td>线</td>
<td>指示线样式</td>
</tr>
</tbody>
</table>
<p>使用方法可在<a href="#/demo/funnel/others">样式调整 demo</a>中查看，用法如下：</p>
<p>在 data 中定义元素样式，可以是 Boolean、 obj 属性或者函数，例如：</p>
<pre v-pre><code v-pre class="language-javascript"><span class="hljs-comment">// 新建funnel组件</span>
<span class="hljs-keyword">const</span> funnel = <span class="hljs-keyword">new</span> Funnel()

<span class="hljs-comment">//设置true或false来隐藏组件元素</span>
<span class="hljs-comment">//隐藏漏斗上的文字</span>
funnel.style(<span class="hljs-string">"text"</span>, <span class="hljs-literal">false</span>)

<span class="hljs-comment">//参考spritejs的attr属性来设置样式</span>
<span class="hljs-comment">//设置指示线样式</span>
funnel.style(<span class="hljs-string">"guideline"</span>, { <span class="hljs-attr">length</span>: <span class="hljs-number">20</span>, <span class="hljs-attr">color</span>: <span class="hljs-string">"#000"</span>, <span class="hljs-attr">lineDash</span>: [<span class="hljs-number">2</span>, <span class="hljs-number">2</span>] })

<span class="hljs-comment">//参数polygon为绘制的polygon属性，dataOrigin为原始数据项，index是绘制索引</span>
funnel.style(<span class="hljs-string">"polygon"</span>, (polygon, dataOrigin, index) =&gt; {
  <span class="hljs-comment">// 根据索引来给每个元素赋色</span>
  <span class="hljs-keyword">if</span> (index % <span class="hljs-number">2</span> === <span class="hljs-number">0</span>) {
    <span class="hljs-keyword">return</span> { <span class="hljs-attr">fillColor</span>: <span class="hljs-string">"#59CB74"</span> }
  }
  <span class="hljs-keyword">return</span> { <span class="hljs-attr">fillColor</span>: <span class="hljs-string">"#FBD54A"</span> }
})
</code></pre>
</section></template><script>export default {components:{}}</script>